import React from 'react';

const CampaignsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default CampaignsPage;
